import { AxiosInstance } from "axios";

import { APIs } from "./APIs";
import { getPath } from "../utils/getPath";

import API = APIs.crmEventsCreate;

export const createCrmEvent = (
  instance: AxiosInstance,
  pathParams: API.PathParam,
  body: API.Body,
  headers: Record<string, string>,
) => {
  return instance[API.method]<API.ResponseData>(
    getPath(API.path, pathParams),
    body,
    { headers },
  );
};
